import React from 'react'

import { GetStaticPaths, GetStaticProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import Image from 'next/image'

import { Article } from '@/components/services'

import { IData } from '@/components/blogImg'
import { PostImage } from '@/components/blogImg/Posts/Sections'
import { FileProvider } from '@/lib/files'
import ArticleSEO from '@/components/blog/article_seo'
import { Social } from '@/components/social'
import { ContactHome } from '@/components/contact'
import gradientImg from '../../public/images/gradient_light.jpg'
import Meta from '@/components/Meta'
import Time from '@/lib/time'
import Config from '../../site.config'

interface IProps {
  data: IData
  slug: string
}

const Single_post = (props: IProps) => {
  const { data, slug } = props

  const { title, date, author } = data.metadata

  const openShareWindow = (url: string) => {
    window.open(url, '_blank', 'width=600,height=400')
  }
  const canonicalURL = `${Config.site.URL}/blog/${slug}`

  return (
    <div>
      <Meta
        title={title}
        canonicalURL={canonicalURL}
        keyList={Config.site.metaTags}
      />
      <ArticleSEO metadata={data.metadata} slug={slug} />

      <div className='relative '>
        {/* <!-- Featured image --> */}
        <PostImage meta={data.metadata} slug={data.slug}></PostImage>
        {/* <!-- Post --> */}
        <section className='py-16 md:py-24'>
          <picture className='pointer-events-none absolute inset-0 -z-10 dark:hidden'>
            <Image
              src={gradientImg}
              alt='gradient'
              priority={true}
              className='h-full w-full'
            />
          </picture>

          <div className='lay'>
            <header className='mx-auto mb-16 max-w-lg text-center'>
              <h1 className='font-display text-jacarta-700 mb-4 text-2xl dark:text-white sm:text-5xl'>
                {title}
              </h1>
              {/* <!-- Author --> */}
              <div className='mb-3 inline-flex flex-wrap items-center space-x-1 text-xs'>
                <span className='text-accent inline-flex flex-wrap items-center space-x-1'>
                  {author} {' \n'}
                </span>
              </div>
              <div className='inline-flex items-center'>
                <div className='text-left'>
                  {/* <!-- Date / Time --> */}
                  <div className='text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm'>
                    <span>•</span>
                    <span>
                      <time>
                        {Time.formatToPost(date as unknown as string)}
                      </time>
                    </span>
                  </div>
                </div>
              </div>
            </header>

            {/* <!-- Article --> */}
            <Article content={data.content} />
            <Social url={canonicalURL} title={title} />
          </div>
        </section>
        {/* <!-- end post --> */}
      </div>
      <ContactHome />
    </div>
  )
}

export default Single_post

export const getStaticPaths: GetStaticPaths = async () => {
  const provider = new FileProvider()
  const postList = provider.getPosts()

  const paths = postList.map((file: IData) => ({
    params: { single_post: file.slug },
  }))

  return { paths, fallback: false }
}

interface IParams extends ParsedUrlQuery {
  single_post: string
}

export const getStaticProps: GetStaticProps = async (context) => {
  const provider = new FileProvider()
  const postList = provider.getPosts()

  const { single_post } = context.params as IParams

  const postData = postList.find((item) => {
    return item.slug == single_post
  })

  return { props: { data: postData, slug: single_post } }
}
